import { useParams as useRouterParams, useLocation } from 'react-router-dom';
import { get } from 'lodash';
import { stringify, parse } from 'query-string';
import { getFullHref } from 'datashop-incare-commons/helpers/engine';
export var routeUsingEngine = function (href) {
    window.skeletonPwa.container.navigateToUrl(getFullHref(href));
    window.handlePushState();
};
export var getPatient360URL = function (patientId) {
    return "/patient/" + patientId + "/summary";
};
export var getCareTimelineURL = function (patientId) {
    return "/patient/" + patientId + "/health-modules/timeline/care-plans";
};
export var assetPublicPath = window.skeletonPwa
    ? window.skeletonPwa.container.appCfg.siteprefix !== '/'
        ? window.skeletonPwa.container.appCfg.siteprefix + "/"
        : "/"
    : '/';
export var urlTransform = function (path) {
    return process.env.NODE_ENV !== 'production' ? path : "" + assetPublicPath + path;
};
export var openInNewTab = function (path) {
    window.open(getFullHref(path), '_blank');
};
export var useEngineRouter = function (href, options) {
    routeUsingEngine(href + options ? "?" + stringify(options) : '');
};
export var useQueryParams = function () {
    return parse(useLocation().search);
};
export var useEmpi = function () {
    return get(useRouterParams(), 'empi');
};
export function useParams(param) {
    if (!param)
        return useRouterParams();
    return get(useRouterParams(), param);
}
//# sourceMappingURL=index.js.map